import React, { useMemo, useState } from 'react';
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../../_metronic/_partials/controls';

import { useReconcileUIContext } from './ReconcileUIContext';
import { ReconcileTable } from './reconcile-table/ReconcileTable';
import { ReconcileFilter } from "./reconcile-filter/ReconcileFilter";
import { BlockOrg, RoleChecker } from '../../../../RoleChecker';
import { Collapse } from 'react-bootstrap';

export const ReconcileCard = () => {

  const [openFilter, setOpenFilter] = useState(false)

    const reconcileUIContext = useReconcileUIContext();
    const reconcileUIProps = useMemo(() => {
        return {
            newReconcileClick: reconcileUIContext.newReconcileClick,
            openEditReconcilePage: reconcileUIContext.openEditReconcilePage,
        };
    }, [reconcileUIContext]);

    return (
        <Card>
            <CardHeader title="Daftar Settlement">
                <CardHeaderToolbar>
                  <button
                        type="button"
                        className="btn btn-warning mx-1"
                        onClick={() => setOpenFilter(!openFilter)}
                        disabled={!RoleChecker("Read", "rekonsiliasi_donasi")}
                    >
                    Pencarian
                  </button>
                {BlockOrg() && (
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={reconcileUIProps.newReconcileClick}
                        disabled={!RoleChecker("Create", "rekonsiliasi_donasi")}
                    >Settlement Baru
                    </button>
                )}
                </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
              <Collapse in={openFilter}>
                    <div id="collapse-filter-settlement">
                      <ReconcileFilter />
                    </div>
                </Collapse>
                <ReconcileTable />

            </CardBody>
        </Card>
    );
};

